/**
     *********************************************************
     Description: Creates drawer on the left side. Needs to be modified to make it generic.
     Required props:  Used internally by other components.
     limitations    : N/A
     *********************************************************
**/
import { Divider, Icon, Popover, Tooltip } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Drawer from '@material-ui/core/Drawer';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from "react-router-dom";
import { handleRules } from '../../core/controls/effects/effects';
import { connect } from 'react-redux';
import { getEnvVariable } from '../../modules/environmentalList';

const styles = theme => ({
    paperAnchorRight: {
        top: 'auto',
        maxHeight: '100%',
    },
    root: {
        width: 300
    },
    scrollButtons: {
        color: '#000', // Change as needed
        fontWeight: 'bold'
    },
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

class LeftSideBar extends Component {

    state = {
        open: false,
        value: 0,
    }
    /**
      *********************************************************
      Description: renders the sidebar with icons. Each icon is a link which when clicked changes the route
      Required props:  N/A.
      limitations    : N/A
      *********************************************************
    **/

    componentDidMount() {
        this.setState({ open: this.props.open })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.open !== prevProps.open) {
            this.setState({ open: this.props.open })
        }
        if ((this.props && this.props.match && this.props.match.params && prevProps.match && prevProps.match.params) && (this.props.match.params.sidebar !== prevProps.match.params.sidebar)) {
            this.handleClose();
        }
    }
    handleOpen = () => {
        this.setState({ open: true })
    };

    handleClose = () => {
        let e = {}
        this.props.handleSidebar(e, false)
        this.setState({ open: false });

    };

    handleLink = (path) => {
        const { showUnSaveAlert, handleSaveConfirm } = this.props
        if (showUnSaveAlert) {
            handleSaveConfirm(null, 'sidebar', path);
        }
        else this.props.history.push(path);
    }

    sidebarList = () => {
        const { options, fieldValues } = this.props
        const { items } = options || { items: [] }
        let pathcontains = this.props && this.props.match && this.props.match.url ? this.props.match.url.substring(this.props.match.url.lastIndexOf('/') + 1) : ""
        let displayOrientation = options && options.orientation ? options.orientation : 'horizontal'
        return (
            items && items.map((each, idx) => {
                const { key, link, hidecondition, check } = each
                let path = ''
                let condition = null;
                let tempFields = fieldValues ? fieldValues : this.props.parentRecordValues
                if (check && tempFields) {
                    let cond1 = !handleRules(check, tempFields)
                    // let cond2 = !handleRules(check2, fieldValues)
                    condition = cond1 === true ? true : false
                }
                else if (hidecondition) {
                    hidecondition.forEach(element => {
                        const { Name, Value, prevcondition, getfrom, notEquals } = element
                        let getdatafrom = getfrom === "localstorage" ? 'localstorage' : getfrom === "requestdata" ?
                            ['reqdata'] : getfrom === "dataItem" ? this.props.dataItem : getfrom === "params" && this.props &&
                                this.props.match && this.props.match.params ? this.props.match.params : this.props
                        if (getdatafrom) {
                            condition = prevcondition && prevcondition === 'or' && condition === true ? true :
                                prevcondition === 'and' && condition === false ? false : (notEquals ? (getfrom === "localstorage" ? localStorage.getItem(Name) !== Value :
                                    getdatafrom[Name] !== Value) : (getfrom === "localstorage" ? localStorage.getItem(Name) === Value : getdatafrom[Name] === Value)) ? true : false
                        }
                    });
                }
                if (condition) {
                    return null
                }
                else if (link) {
                    if (Array.isArray(link)) {
                        link.forEach(e => {
                            const { link, routes, linkParams, params } = e
                            if (Array.isArray(routes)) {
                                routes.forEach(each => {
                                    const { route, routeParams, matchProps } = each
                                    if (routeParams) {
                                        path += route + "/" + this.props.match.params[routeParams]
                                    }
                                    else if (matchProps) {
                                        path += route + "/" + this.props.results[matchProps]
                                    }
                                    else {
                                        path += route
                                    }
                                })
                            }
                            else {
                                if (linkParams) path += link + this.props.match.params[linkParams]
                                else if (params) path += link + this.props[params]
                                else path += link
                            }

                        })
                    }
                    else path = link
                    return <div className={each.hide ? this.props.hide ? 'd-none' : 'd-block' : 'd-block'} key={idx}  >
                        {/* <Tooltip title={each.title} placement="top"> */}
                        {/* <Link key={key} to={()=>this.handleLink(path)} style={{ textDecoration: 'none' }} > */}
                        <ListItem button
                            onClick={() => this.handleLink(path)}
                            style={{
                                backgroundColor: (key === pathcontains) ? "#d8e7f3" : "#ffffff",
                                '&:hover': {
                                    backgroundColor: '#d8e7f3'
                                },
                                margin: 0,
                                px: 1,
                            }}>
                                < Icon fontSize="small" style={each.style}>{each.materialicon}</Icon>
                                {(key === pathcontains) && <Typography variant="caption" display="block" style={{ color: "#3F51B5" }} className="ps-1 pt-1" gutterBottom>
                                    <b>{each.title}</b>
                                </Typography>}
                                {(key !== pathcontains) && <Typography variant="caption" display="block" style={{ color: "#000000" }} className="ps-1 pt-1" gutterBottom>
                                    {each.title}
                                </Typography>}
                            </ListItem>
                            {displayOrientation === 'vertical' && <Divider />}
                        {/* </Link> */}
                        {/* </Tooltip> */}
                    </ div>
                }
            })
        )
    }


    render() {
        const { classes, options, anchorElSidebar } = this.props
        const { open } = this.state
        let displayOrientation = (getEnvVariable("RecordSidebarOrientation") === 'T' ? 'horizontal' : 'vertical')
        return (
            <>
                {displayOrientation === 'horizontal' && <AppBar className="mt-2 me-1 pe-5" position="static" color="white"
                    elevation={0} style={{
                        borderRadius: '10px', // Add this line
                        padding: '0px',
                        margin: '0px',
                        fontSize: '0.5rem',
                    }}>
                    <Tabs
                        style={{ fontSize: '0.5rem', padding: 0, m: 0 }}
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="white"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                        classes={{ scrollButtons: classes.scrollButtons }}
                    >
                        {this.sidebarList()}
                    </Tabs>
                </AppBar>}
                {displayOrientation === 'vertical' && <div className="eps-application-drawer">
                    <Popover
                        id="simple-popover"
                        anchorEl={anchorElSidebar}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={open} // replace with your state variable
                        // anchorReference="anchorPosition"
                        anchorPosition={{ top: 50, left: 50 }}
                        onClose={this.handleClose}                    >
                        {this.sidebarList()}
                    </Popover></div>}
            </>
        )
    }

}

const mapProps = (state) => {
    return { parentRecordValues: (state && state.sidebar ? state.sidebar.modules : false) }
}


LeftSideBar = connect(mapProps, null)(LeftSideBar);

export default withStyles(styles)(withRouter(LeftSideBar));